// M05 百分法 - 主題 01-05 數據文件
// Percentage Method - Topics 01-05
// 系統化設計，準備後續 Supabase 數據遷移

// M05-01: 分數轉百分數 (Fraction to Percentage Conversion)
export const M05_01_PROBLEMS = [
  {
    id: "M05_01_001",
    topicId: "M05_01",
    question: "分數轉百分數的基本計算：\n(a) 將 3/4 轉換為百分數\n(b) 將 5/8 轉換為百分數，保留一位小數\n(c) 將 7/12 轉換為百分數，保留兩位小數",
    solution: "(a) 75%, (b) 62.5%, (c) 58.33%",
    explanation: "分數轉百分數的方法是將分數乘以100%，或先化為小數再乘以100%。",
    hint: "記住：分數 × 100% = 百分數，或先除法得小數，再乘以100%。",
    difficulty: 1,
    order: 1,
    steps: [
      "(a) 3/4 = 0.75，0.75 × 100% = 75%",
      "(b) 5/8 = 0.625，0.625 × 100% = 62.5%",
      "(c) 7/12 = 0.5833...，0.5833 × 100% = 58.33%"
    ]
  },
  {
    id: "M05_01_002",
    topicId: "M05_01",
    question: "複合分數的百分數轉換：\n(a) 將 2 3/5 轉換為百分數\n(b) 將 1 7/8 轉換為百分數\n(c) 比較 2 3/5 和 260% 的大小",
    solution: "(a) 260%, (b) 187.5%, (c) 2 3/5 = 260%，相等",
    explanation: "帶分數先轉為假分數，再按正常方法轉換為百分數。",
    hint: "帶分數 = 整數部分 + 分數部分，先統一為假分數。",
    difficulty: 2,
    order: 2,
    steps: [
      "(a) 2 3/5 = 13/5 = 2.6，2.6 × 100% = 260%",
      "(b) 1 7/8 = 15/8 = 1.875，1.875 × 100% = 187.5%",
      "(c) 2 3/5 = 260%，與260%相等"
    ]
  },
  {
    id: "M05_01_003",
    topicId: "M05_01",
    question: "循環小數的百分數表示：\n(a) 將 1/3 轉換為百分數（精確值）\n(b) 將 2/9 轉換為百分數（精確值）\n(c) 將 5/6 轉換為百分數，保留三位小數",
    solution: "(a) 33.333...% 或 33⅓%, (b) 22.222...% 或 22²⁄₉%, (c) 83.333%",
    explanation: "循環小數可以用分數形式表示，或根據需要保留適當位數。",
    hint: "循環小數轉百分數時，可保留分數形式或按要求保留小數位數。",
    difficulty: 2,
    order: 3,
    steps: [
      "(a) 1/3 = 0.333...，0.333... × 100% = 33.333...% = 33⅓%",
      "(b) 2/9 = 0.222...，0.222... × 100% = 22.222...% = 22²⁄₉%",
      "(c) 5/6 = 0.8333...，0.8333 × 100% = 83.333%"
    ]
  },
  {
    id: "M05_01_004",
    topicId: "M05_01",
    question: "實際應用中的分數轉百分數：\n(a) 某班45名學生中，27名是男生，求男生所佔百分比\n(b) 一份試卷120分，小明得96分，求得分率\n(c) 工廠生產1000件產品，合格品980件，求合格率",
    solution: "(a) 60%, (b) 80%, (c) 98%",
    explanation: "實際問題中，先建立分數關係，再轉換為百分數。",
    hint: "實際問題：所求量/總量 × 100% = 百分比。",
    difficulty: 2,
    order: 4,
    steps: [
      "(a) 男生比例 = 27/45 = 3/5 = 0.6 = 60%",
      "(b) 得分率 = 96/120 = 4/5 = 0.8 = 80%",
      "(c) 合格率 = 980/1000 = 98/100 = 98%"
    ]
  },
  {
    id: "M05_01_005",
    topicId: "M05_01",
    question: "負分數的百分數轉換：\n(a) 將 -3/4 轉換為百分數\n(b) 將 -2 1/5 轉換為百分數\n(c) 比較 -75% 和 -3/4 的大小",
    solution: "(a) -75%, (b) -220%, (c) -75% = -3/4，相等",
    explanation: "負分數轉百分數時，保持負號，按正常方法計算。",
    hint: "負分數的符號在轉換過程中保持不變。",
    difficulty: 3,
    order: 5,
    steps: [
      "(a) -3/4 = -0.75，-0.75 × 100% = -75%",
      "(b) -2 1/5 = -11/5 = -2.2，-2.2 × 100% = -220%",
      "(c) -3/4 = -75%，與-75%相等"
    ]
  },
  {
    id: "M05_01_006",
    topicId: "M05_01",
    question: "綜合轉換練習：\n(a) 將 0.125, 1/8, 12.5% 按從小到大排列\n(b) 找出等於 75% 的三種不同表示法\n(c) 計算：3/8 + 37.5% - 0.75 的百分數形式",
    solution: "(a) 三者相等：0.125 = 1/8 = 12.5%, (b) 75% = 3/4 = 0.75, (c) 0%",
    explanation: "不同形式的數值可能相等，需要統一單位進行比較和計算。",
    hint: "統一轉換為同一形式（小數、分數或百分數）再進行比較和運算。",
    difficulty: 3,
    order: 6,
    steps: [
      "(a) 0.125 = 1/8 = 12.5%，三者相等",
      "(b) 75% = 75/100 = 3/4 = 0.75",
      "(c) 3/8 = 37.5%，所以 37.5% + 37.5% - 75% = 0%"
    ]
  }
];

// M05-02: 百分數計算 (Percentage Calculations)
export const M05_02_PROBLEMS = [
  {
    id: "M05_02_001",
    topicId: "M05_02",
    question: "基本百分數計算：\n(a) 求 200 的 25% 是多少\n(b) 求 80 的 125% 是多少\n(c) 求 150 的 66⅔% 是多少",
    solution: "(a) 50, (b) 100, (c) 100",
    explanation: "百分數乘法：原數 × 百分數 = 所求數。",
    hint: "百分數計算公式：原數 × 百分率 = 百分數值。",
    difficulty: 1,
    order: 1,
    steps: [
      "(a) 200 × 25% = 200 × 0.25 = 50",
      "(b) 80 × 125% = 80 × 1.25 = 100",
      "(c) 150 × 66⅔% = 150 × ⅔ = 100"
    ]
  },
  {
    id: "M05_02_002",
    topicId: "M05_02",
    question: "百分數的連續計算：\n(a) 120 的 30% 的 40% 是多少\n(b) 80 增加 25% 後再減少 20% 是多少\n(c) 100 減少 10% 後再增加 10% 是多少",
    solution: "(a) 14.4, (b) 80, (c) 99",
    explanation: "連續百分數計算要按順序進行，注意基數的變化。",
    hint: "連續計算時，第二次計算的基數是第一次計算的結果。",
    difficulty: 2,
    order: 2,
    steps: [
      "(a) 120 × 30% = 36，36 × 40% = 14.4",
      "(b) 120 × (1 + 25%) = 100，100 × (1 - 20%) = 80",
      "(c) 100 × (1 - 10%) = 90，90 × (1 + 10%) = 99"
    ]
  },
  {
    id: "M05_02_003",
    topicId: "M05_02",
    question: "百分數方程的建立與求解：\n(a) 某數的 60% 等於 72，求這個數\n(b) 某數的 125% 比某數多 50，求這個數\n(c) 兩數之和為 180，其中一數是另一數的 80%，求兩數",
    solution: "(a) 120, (b) 200, (c) 80和100",
    explanation: "建立百分數方程，通過代數方法求解未知數。",
    hint: "設未知數為x，根據題意建立方程。",
    difficulty: 3,
    order: 3,
    steps: [
      "(a) 設數為x，則 x × 60% = 72，x = 72 ÷ 0.6 = 120",
      "(b) 設數為x，則 1.25x - x = 50，0.25x = 50，x = 200",
      "(c) 設兩數為x和0.8x，則 x + 0.8x = 180，1.8x = 180，x = 100，另一數為80"
    ]
  },
  {
    id: "M05_02_004",
    topicId: "M05_02",
    question: "百分數的混合運算：\n(a) 計算：20% × 150 + 30% × 200\n(b) 計算：(40% + 60%) × 80 - 25% × 120\n(c) 計算：150 × (1 + 20%) × (1 - 10%)",
    solution: "(a) 90, (b) 50, (c) 162",
    explanation: "百分數混合運算遵循四則運算法則，注意運算順序。",
    hint: "先算括號內，再算乘除，最後算加減。",
    difficulty: 2,
    order: 4,
    steps: [
      "(a) 20% × 150 + 30% × 200 = 30 + 60 = 90",
      "(b) (40% + 60%) × 80 - 25% × 120 = 100% × 80 - 30 = 80 - 30 = 50",
      "(c) 150 × 1.2 × 0.9 = 180 × 0.9 = 162"
    ]
  },
  {
    id: "M05_02_005",
    topicId: "M05_02",
    question: "實際問題中的百分數計算：\n(a) 某商品原價500元，打8折後價格是多少\n(b) 某班50名學生，男生佔60%，女生有多少人\n(c) 某工廠計劃生產1000件產品，已完成75%，還需生產多少件",
    solution: "(a) 400元, (b) 20人, (c) 250件",
    explanation: "實際問題要理解百分數的實際意義，正確建立計算關係。",
    hint: "理解題意，找出基數和百分率，套用公式計算。",
    difficulty: 2,
    order: 5,
    steps: [
      "(a) 打8折 = 80%，500 × 80% = 400元",
      "(b) 男生60%，女生40%，50 × 40% = 20人",
      "(c) 已完成75%，剩餘25%，1000 × 25% = 250件"
    ]
  },
  {
    id: "M05_02_006",
    topicId: "M05_02",
    question: "百分數的逆向思維：\n(a) 已知某數的40%是80，求這個數的60%\n(b) 某數增加25%後是100，求原數的75%\n(c) 兩數的平均數是90，其中一數比平均數多20%，求另一數",
    solution: "(a) 120, (b) 60, (c) 72",
    explanation: "逆向思維要先求出原數或基數，再進行相關計算。",
    hint: "先通過已知條件求出基數，再計算所求量。",
    difficulty: 3,
    order: 6,
    steps: [
      "(a) 某數 = 80 ÷ 40% = 200，200 × 60% = 120",
      "(b) 原數 = 100 ÷ 125% = 80，80 × 75% = 60",
      "(c) 一數 = 90 × 120% = 108，另一數 = 180 - 108 = 72"
    ]
  }
];

// M05-03: 原數還原 (Original Number Recovery)
export const M05_03_PROBLEMS = [
  {
    id: "M05_03_001",
    topicId: "M05_03",
    question: "基本原數還原問題：\n(a) 某數增加20%後是120，求原數\n(b) 某數減少25%後是75，求原數\n(c) 某數的80%是64，求原數",
    solution: "(a) 100, (b) 100, (c) 80",
    explanation: "原數還原的基本方法：結果數 ÷ 變化後的百分率 = 原數。",
    hint: "增加20%意味著變成120%，減少25%意味著變成75%。",
    difficulty: 1,
    order: 1,
    steps: [
      "(a) 原數 = 120 ÷ (1 + 20%) = 120 ÷ 1.2 = 100",
      "(b) 原數 = 75 ÷ (1 - 25%) = 75 ÷ 0.75 = 100",
      "(c) 原數 = 64 ÷ 80% = 64 ÷ 0.8 = 80"
    ]
  },
  {
    id: "M05_03_002",
    topicId: "M05_03",
    question: "複雜的原數還原：\n(a) 某數先增加10%，再減少10%後是99，求原數\n(b) 某數先減少20%，再增加25%後是100，求原數\n(c) 某數的120%的75%是90，求原數",
    solution: "(a) 100, (b) 100, (c) 100",
    explanation: "多步變化的原數還原，要逆向逐步計算或建立方程。",
    hint: "可以逆向計算，也可以設原數為x建立方程。",
    difficulty: 2,
    order: 2,
    steps: [
      "(a) 設原數為x，x × 1.1 × 0.9 = 99，x × 0.99 = 99，x = 100",
      "(b) 設原數為x，x × 0.8 × 1.25 = 100，x × 1 = 100，x = 100",
      "(c) 設原數為x，x × 120% × 75% = 90，x × 0.9 = 90，x = 100"
    ]
  },
  {
    id: "M05_03_003",
    topicId: "M05_03",
    question: "實際問題中的原數還原：\n(a) 某商品打8折後售價320元，求原價\n(b) 某班學生人數減少10%後是45人，求原來人數\n(c) 某工人完成任務的75%，還剩150件，求總任務量",
    solution: "(a) 400元, (b) 50人, (c) 600件",
    explanation: "實際問題中要理解百分數變化的實際含義。",
    hint: "找出變化後的百分率，用除法還原原數。",
    difficulty: 2,
    order: 3,
    steps: [
      "(a) 打8折 = 80%，原價 = 320 ÷ 80% = 400元",
      "(b) 減少10% = 90%，原人數 = 45 ÷ 90% = 50人",
      "(c) 完成75%，剩餘25%，總量 = 150 ÷ 25% = 600件"
    ]
  },
  {
    id: "M05_03_004",
    topicId: "M05_03",
    question: "含有未知百分率的還原問題：\n(a) 某數增加某個百分比後是130，且增加量是26，求原數和百分比\n(b) 某數減少某個百分比後是80，且減少量是20，求原數和百分比\n(c) 某數的某個百分比是45，且這個百分比比50%少10%，求原數",
    solution: "(a) 原數104，增加25%, (b) 原數100，減少20%, (c) 原數112.5",
    explanation: "含有兩個未知量的問題，需要建立兩個方程或利用數量關係。",
    hint: "利用增加量或減少量建立關係式。",
    difficulty: 3,
    order: 4,
    steps: [
      "(a) 原數 = 130 - 26 = 104，百分比 = 26 ÷ 104 = 25%",
      "(b) 原數 = 80 + 20 = 100，百分比 = 20 ÷ 100 = 20%",
      "(c) 百分比 = 50% - 10% = 40%，原數 = 45 ÷ 40% = 112.5"
    ]
  },
  {
    id: "M05_03_005",
    topicId: "M05_03",
    question: "多個條件的原數還原：\n(a) 甲數的60%等於乙數的40%，且甲乙兩數之和是200，求甲乙兩數\n(b) 某數增加20%等於另一數減少25%，且兩數之和是350，求兩數\n(c) 三個數的比是2:3:5，最大數的40%是60，求三個數",
    solution: "(a) 甲80，乙120, (b) 第一個數150，第二個數200, (c) 60，90，150",
    explanation: "多個條件的問題要建立方程組求解。",
    hint: "設未知數，根據條件建立方程組。",
    difficulty: 3,
    order: 5,
    steps: [
      "(a) 設甲為x，乙為y，0.6x = 0.4y，x + y = 200，解得x = 80，y = 120",
      "(b) 設兩數為x，y，1.2x = 0.75y，x + y = 350，解得x = 150，y = 200",
      "(c) 最大數 = 60 ÷ 40% = 150，比例2:3:5，所以三數為60，90，150"
    ]
  },
  {
    id: "M05_03_006",
    topicId: "M05_03",
    question: "綜合原數還原應用：\n(a) 某商品先漲價10%，再降價10%，最終比原價少2元，求原價\n(b) 某班男生人數的80%等於女生人數的60%，全班共48人，求男女生人數\n(c) 兩個數的平均數是75，其中一個數比另一個數多20%，求兩數",
    solution: "(a) 200元, (b) 男生18人，女生30人, (c) 第一個數約68.18，第二個數約81.82",
    explanation: "綜合問題要分析各種數量關係，選擇合適的解題方法。",
    hint: "仔細分析題意，建立正確的數學關係。",
    difficulty: 4,
    order: 6,
    steps: [
      "(a) 設原價x，x × 1.1 × 0.9 = x - 2，0.99x = x - 2，x = 200",
      "(b) 設男生x，女生y，0.8x = 0.6y，x + y = 48，解得x = 18，y = 30",
      "(c) 設兩數為x和1.2x，(x + 1.2x) ÷ 2 = 75，x = 68.18，1.2x = 81.82"
    ]
  }
];

// M05-04: 百分增加 (Percentage Increase)
export const M05_04_PROBLEMS = [
  {
    id: "M05_04_001",
    topicId: "M05_04",
    question: "基本百分增加計算：\n(a) 100增加30%後是多少\n(b) 80增加125%後是多少\n(c) 某數增加50%後是90，求原數",
    solution: "(a) 130, (b) 180, (c) 60",
    explanation: "百分增加：新數 = 原數 × (1 + 增加率)。",
    hint: "增加30%意味著變成130%。",
    difficulty: 1,
    order: 1,
    steps: [
      "(a) 100 × (1 + 30%) = 100 × 1.3 = 130",
      "(b) 80 × (1 + 125%) = 80 × 2.25 = 180",
      "(c) 原數 = 90 ÷ (1 + 50%) = 90 ÷ 1.5 = 60"
    ]
  },
  {
    id: "M05_04_002",
    topicId: "M05_04",
    question: "連續百分增加：\n(a) 100連續兩次各增加20%後是多少\n(b) 某數先增加10%，再增加20%後是132，求原數\n(c) 某數每年增加15%，3年後變成152.1，求原數",
    solution: "(a) 144, (b) 100, (c) 100",
    explanation: "連續增加要逐步計算，或用複合增長公式。",
    hint: "連續增加：原數 × (1 + 增加率₁) × (1 + 增加率₂)。",
    difficulty: 2,
    order: 2,
    steps: [
      "(a) 100 × 1.2 × 1.2 = 144",
      "(b) 原數 = 132 ÷ (1.1 × 1.2) = 132 ÷ 1.32 = 100",
      "(c) 原數 = 152.1 ÷ (1.15)³ = 152.1 ÷ 1.521 = 100"
    ]
  },
  {
    id: "M05_04_003",
    topicId: "M05_04",
    question: "實際問題中的百分增加：\n(a) 某商品原價200元，漲價15%後售價是多少\n(b) 某公司員工原有150人，增加20%後有多少人\n(c) 某城市人口原有50萬，每年增長3%，5年後人口約多少萬",
    solution: "(a) 230元, (b) 180人, (c) 約57.96萬",
    explanation: "實際問題要理解百分增加的實際意義。",
    hint: "找出基數和增加率，套用增加公式。",
    difficulty: 2,
    order: 3,
    steps: [
      "(a) 售價 = 200 × (1 + 15%) = 200 × 1.15 = 230元",
      "(b) 員工數 = 150 × (1 + 20%) = 150 × 1.2 = 180人",
      "(c) 人口 = 50 × (1.03)⁵ = 50 × 1.1593 ≈ 57.96萬"
    ]
  },
  {
    id: "M05_04_004",
    topicId: "M05_04",
    question: "百分增加率的計算：\n(a) 某數從80變成96，求增加率\n(b) 某商品價格從150元變成180元，求漲價率\n(c) 某班學生從40人增加到50人，求增加率",
    solution: "(a) 20%, (b) 20%, (c) 25%",
    explanation: "增加率 = (新數 - 原數) ÷ 原數 × 100%。",
    hint: "增加率 = 增加量 ÷ 原數 × 100%。",
    difficulty: 2,
    order: 4,
    steps: [
      "(a) 增加率 = (96 - 80) ÷ 80 × 100% = 16 ÷ 80 × 100% = 20%",
      "(b) 漲價率 = (180 - 150) ÷ 150 × 100% = 30 ÷ 150 × 100% = 20%",
      "(c) 增加率 = (50 - 40) ÷ 40 × 100% = 10 ÷ 40 × 100% = 25%"
    ]
  },
  {
    id: "M05_04_005",
    topicId: "M05_04",
    question: "複合增長問題：\n(a) 某投資第一年增長20%，第二年增長25%，兩年總增長率是多少\n(b) 某產品產量連續三年分別增長10%、15%、20%，三年總增長率是多少\n(c) 某數先增加a%，再增加b%，總增長率用a、b表示",
    solution: "(a) 50%, (b) 51.8%, (c) (a + b + ab/100)%",
    explanation: "複合增長率不是簡單相加，要用乘積計算。",
    hint: "總增長率 = (1 + 增長率₁) × (1 + 增長率₂) - 1。",
    difficulty: 3,
    order: 5,
    steps: [
      "(a) 總增長率 = 1.2 × 1.25 - 1 = 1.5 - 1 = 50%",
      "(b) 總增長率 = 1.1 × 1.15 × 1.2 - 1 = 1.518 - 1 = 51.8%",
      "(c) 總增長率 = (1 + a/100)(1 + b/100) - 1 = (a + b + ab/100)%"
    ]
  },
  {
    id: "M05_04_006",
    topicId: "M05_04",
    question: "增長模型的應用：\n(a) 某細菌每小時增長50%，8小時後數量變成原來的多少倍\n(b) 某投資年收益率12%，多少年後本金翻倍（保留整數）\n(c) 某城市GDP連續5年平均增長8%，5年後GDP是原來的多少倍",
    solution: "(a) 25.63倍, (b) 7年, (c) 1.47倍",
    explanation: "指數增長模型：A = P(1 + r)ⁿ，其中A是最終值，P是初始值。",
    hint: "利用指數增長公式，注意對數計算。",
    difficulty: 4,
    order: 6,
    steps: [
      "(a) 倍數 = (1.5)⁸ = 25.63倍",
      "(b) 2 = (1.12)ⁿ，n = log₁.₁₂(2) ≈ 6.12，取7年",
      "(c) 倍數 = (1.08)⁵ = 1.469 ≈ 1.47倍"
    ]
  }
];

// M05-05: 變化百分數 (Percentage Change)
export const M05_05_PROBLEMS = [
  {
    id: "M05_05_001",
    topicId: "M05_05",
    question: "基本變化百分數：\n(a) 某數從120變成90，求變化百分數\n(b) 某數從80變成100，求變化百分數\n(c) 某數從150變成150，求變化百分數",
    solution: "(a) -25%, (b) +25%, (c) 0%",
    explanation: "變化百分數 = (新數 - 原數) ÷ 原數 × 100%，正數表示增加，負數表示減少。",
    hint: "變化百分數可以是正數（增加）、負數（減少）或零（不變）。",
    difficulty: 1,
    order: 1,
    steps: [
      "(a) 變化百分數 = (90 - 120) ÷ 120 × 100% = -30 ÷ 120 × 100% = -25%",
      "(b) 變化百分數 = (100 - 80) ÷ 80 × 100% = 20 ÷ 80 × 100% = +25%",
      "(c) 變化百分數 = (150 - 150) ÷ 150 × 100% = 0 ÷ 150 × 100% = 0%"
    ]
  },
  {
    id: "M05_05_002",
    topicId: "M05_05",
    question: "實際問題中的變化百分數：\n(a) 某商品價格從200元變成160元，求價格變化率\n(b) 某班學生從45人變成54人，求人數變化率\n(c) 某股票從每股50元跌到40元，求跌幅",
    solution: "(a) -20%, (b) +20%, (c) -20%",
    explanation: "實際問題中的變化率反映了數量的相對變化程度。",
    hint: "負變化率表示下降，正變化率表示上升。",
    difficulty: 2,
    order: 2,
    steps: [
      "(a) 價格變化率 = (160 - 200) ÷ 200 × 100% = -40 ÷ 200 × 100% = -20%",
      "(b) 人數變化率 = (54 - 45) ÷ 45 × 100% = 9 ÷ 45 × 100% = +20%",
      "(c) 跌幅 = (40 - 50) ÷ 50 × 100% = -10 ÷ 50 × 100% = -20%"
    ]
  },
  {
    id: "M05_05_003",
    topicId: "M05_05",
    question: "連續變化的百分數：\n(a) 某數先增加20%，再減少20%，總變化百分數是多少\n(b) 某數先減少10%，再增加10%，總變化百分數是多少\n(c) 某數先增加50%，再減少多少百分比能回到原數",
    solution: "(a) -4%, (b) -1%, (c) 33⅓%",
    explanation: "連續變化的總變化率不是簡單的代數和。",
    hint: "總變化率 = 最終結果 ÷ 原數 - 1。",
    difficulty: 3,
    order: 3,
    steps: [
      "(a) 最終 = 原數 × 1.2 × 0.8 = 0.96 × 原數，總變化 = -4%",
      "(b) 最終 = 原數 × 0.9 × 1.1 = 0.99 × 原數，總變化 = -1%",
      "(c) 增加50%後為1.5倍，需減少1/3，即33⅓%"
    ]
  },
  {
    id: "M05_05_004",
    topicId: "M05_05",
    question: "變化百分數的比較：\n(a) A從100變成120，B從200變成230，哪個變化率大\n(b) 甲商品降價30元，原價150元；乙商品降價40元，原價250元，哪個降價幅度大\n(c) 某班男生增加3人（原有15人），女生增加4人（原有25人），哪個增長率大",
    solution: "(a) A變化率大(20% > 15%), (b) 甲降價幅度大(20% > 16%), (c) 男生增長率大(20% > 16%)",
    explanation: "比較變化程度要看變化百分數，而不是絕對變化量。",
    hint: "相對變化比絕對變化更能反映變化的程度。",
    difficulty: 2,
    order: 4,
    steps: [
      "(a) A變化率 = 20/100 = 20%，B變化率 = 30/200 = 15%，A大",
      "(b) 甲降價率 = 30/150 = 20%，乙降價率 = 40/250 = 16%，甲大",
      "(c) 男生增長率 = 3/15 = 20%，女生增長率 = 4/25 = 16%，男生大"
    ]
  },
  {
    id: "M05_05_005",
    topicId: "M05_05",
    question: "變化百分數的應用：\n(a) 某產品銷量從月初的1000件變成月末的1200件，求月增長率\n(b) 某公司股價週一收盤80元，週五收盤72元，求週跌幅\n(c) 某地氣溫從上午的15°C變成下午的21°C，求升溫率",
    solution: "(a) +20%, (b) -10%, (c) +40%",
    explanation: "各種實際場景中都可以用變化百分數來描述變化程度。",
    hint: "變化率是一個通用的概念，適用於各種數量的變化。",
    difficulty: 2,
    order: 5,
    steps: [
      "(a) 月增長率 = (1200 - 1000) ÷ 1000 × 100% = 200 ÷ 1000 × 100% = +20%",
      "(b) 週跌幅 = (72 - 80) ÷ 80 × 100% = -8 ÷ 80 × 100% = -10%",
      "(c) 升溫率 = (21 - 15) ÷ 15 × 100% = 6 ÷ 15 × 100% = +40%"
    ]
  },
  {
    id: "M05_05_006",
    topicId: "M05_05",
    question: "複雜變化百分數問題：\n(a) 甲乙兩數原來相等，甲增加20%，乙減少15%，現在甲比乙多百分之幾\n(b) 某商品先漲價25%，再降價20%，問最終價格比原價變化多少\n(c) 兩個相等的數，一個增加a%，另一個減少b%，問前者比後者多百分之幾",
    solution: "(a) 約41.18%, (b) 0%, (c) (a+b)/(100-b) × 100%",
    explanation: "複雜問題要仔細分析各種數量關係。",
    hint: "設原數為基準，分別計算變化後的數值。",
    difficulty: 4,
    order: 6,
    steps: [
      "(a) 設原數100，甲變成120，乙變成85，甲比乙多(120-85)÷85×100% ≈ 41.18%",
      "(b) 最終價格 = 原價 × 1.25 × 0.8 = 原價，變化0%",
      "(c) 設原數100，變化後分別為100+a和100-b，差異率 = (a+b)/(100-b) × 100%"
    ]
  }
]; 